import { render, staticRenderFns } from "./d-root-pharmacy-orders-new.vue?vue&type=template&id=742d22c2"
import script from "./d-root-pharmacy-orders-new.vue?vue&type=script&lang=js"
export * from "./d-root-pharmacy-orders-new.vue?vue&type=script&lang=js"
import style0 from "./d-root-pharmacy-orders-new.vue?vue&type=style&index=0&id=742d22c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports